/**
 * TODO - preamble
 */
import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { produce } from 'immer';

import {
    validateFieldById,
    getFieldValidationErrors,
    isFormFilled,
    isFormErrored,
    CollegeNameComponent,
    FirstNameComponent,
    LastNameComponent,
    EmailComponent,
    FormFooterComponent,
    HowDoesVerifyingWorkComponent,
    OptInComponent,
    logger,
    VerificationService,
    StudentPersonalInfoViewModel,
    FieldValidationErrors,
    Organization,
    FieldId,
    FieldContent,
    ExtendedFieldValidationErrors,
    ExtendedFieldId,
    Metadata,
    submitForm,
    VerificationStepsEnum,
    LogoComponent,
} from '@sheerid/jslib';


import { BirthDateComponent } from './BirthDate2Component';

interface StepStudentPersonalInfoComponentProps {
    intl: any;
    verificationService: VerificationService;
}

const StepStudentPersonalInfo = ({ intl, verificationService }: StepStudentPersonalInfoComponentProps) => {
    const viewModel = verificationService.viewModel as StudentPersonalInfoViewModel;
    const fieldValidationErrors: FieldValidationErrors & ExtendedFieldValidationErrors = verificationService.fieldValidationErrors;

    const updateViewModel = (key, value: string | Metadata) => {
        const nextState = produce(viewModel, (draft) => {
            draft[key] = value;
        });
        verificationService.updateViewModel(nextState);
    };

    const updateViewModelOrganization = (choice: Organization) => {
        const nextState = produce(viewModel, (draft: StudentPersonalInfoViewModel) => {
            draft.organization.id = choice.id;
            draft.organization.name = choice.name;
        });
        verificationService.updateViewModel(nextState);
    };

    const updateFieldValidationErrorsByFieldId = (fieldId: FieldId | ExtendedFieldId, value: FieldContent) => {
        const nextState = produce(fieldValidationErrors, (draft) => {
            if (draft[fieldId]) {
                draft[fieldId] = validateFieldById(fieldId, value);
            }
        });
        updateFieldValidationErrors(nextState);
    };

    const updateFieldValidationErrors = (fieldValidationErrors: FieldValidationErrors) => {
        verificationService.updateFieldValidationErrors(fieldValidationErrors);
    };

    return (
        <div id="sid-step-student-personal-info" className="sid-l-container">

            <header className="sid-header">
                <div className="sid-l-horz-center">
                     <LogoComponent verificationService={verificationService} />
                </div>
                <div className="sid-header__title sid-l-space-top-lg">
                    <FormattedHTMLMessage id="step.personalInfo.title" defaultMessage="Unlock this Student-Only Offer" />
                </div>
                <div className="sid-header__subtitle sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.personalInfo.subtitle"
                        defaultMessage="Verify you're a student at a US, degree-granting college or university." />
                    &nbsp;
                    <HowDoesVerifyingWorkComponent verificationService={verificationService} />
                </div>
            </header>

            <CollegeNameComponent
                value={(verificationService.viewModel as StudentPersonalInfoViewModel).organization}
                verificationService = {verificationService}
                isErrored={!!fieldValidationErrors.organization}
                onChange={
                    (choice: Organization) => {
                        updateViewModelOrganization(choice);
                        updateFieldValidationErrorsByFieldId('organization', choice);
                    }
                }
                placeholder = "School Name"
            />

            <div className="sid-names">
                <FirstNameComponent
                    value={viewModel.firstName}
                    isErrored={!!fieldValidationErrors.firstName}
                    onChange={
                        (newValue) => {
                            updateViewModel('firstName', newValue);
                            updateFieldValidationErrorsByFieldId('firstName', newValue);
                        }
                    }
                    placeholder = "First Name"
                />

                <LastNameComponent
                    value={viewModel.lastName}
                    isErrored={!!fieldValidationErrors.lastName}
                    onChange={
                        (newValue) => {
                            updateViewModel('lastName', newValue);
                            updateFieldValidationErrorsByFieldId('lastName', newValue);
                        }
                    }
                    placeholder = "Last Name"
                />
            </div>

            <EmailComponent
                value={viewModel.email}
                isErrored={!!fieldValidationErrors.email}
                explanation={" "}
                onChange={
                    (newValue) => {
                        updateViewModel('email', newValue);
                        updateFieldValidationErrorsByFieldId('email', newValue);
                    }
                }
                placeholder = "Email"
            />

            <BirthDateComponent
                isErrored={!!fieldValidationErrors.birthDate}
                errorMessage={fieldValidationErrors.birthDate}
                onChange={(newValue) => {
                    updateViewModel('birthDate', newValue);
                    updateFieldValidationErrorsByFieldId('birthDate', newValue);
                }}
                value={viewModel.birthDate}
            />

            {viewModel.metadata && viewModel.metadata.hasOwnProperty('optin') ?
                <OptInComponent
                    value={viewModel.metadata.optin}
                    onChange={
                        (newValue) => {
                            updateViewModel('metadata', { optin: newValue });
                        }
                    }
                />
                : null
            }
            <div className="sid-form-region sid-submit-wrapper sid-l-space-top-md">
                <button
                    onClick={() => submitForm(viewModel, verificationService, VerificationStepsEnum.collectStudentPersonalInfo)}
                    type="submit"
                    className={`sid-btn sid-btn--dark sid-l-full-width ${!isFormFilled(viewModel) ? 'sid-btn--disabled-like' : ''}`}
                    aria-label="submit"
                >
                    <FormattedHTMLMessage id="verifyMyStudentStatus" defaultMessage="Verify My Student Status" />
                </button>
            </div>

            <FormFooterComponent verificationService={verificationService}>
                <FormattedHTMLMessage
                    id="studentInfoShared"
                    defaultMessage={'Information entered here will be used for verification purposes.'}
                />
            </FormFooterComponent>
        </div>
    );
};

export const StepStudentPersonalInfoComponent = StepStudentPersonalInfo;
